module.exports = __webpack_public_path__ + "images/emoji/chicken.1926fbaf5d00492fefbd.png";